/**
 * Coerce post `tags` from Supabase/JSON (array, JSON string, or plain string) into string[].
 * Prevents runtime errors when callers use .map/.forEach (strings have length but no .map).
 */
export function normalizePostTags(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map((t) => String(t)).filter(Boolean);
  }
  if (typeof value === 'string') {
    const s = value.trim();
    if (!s) return [];
    if (s.startsWith('[')) {
      try {
        const parsed = JSON.parse(s) as unknown;
        if (Array.isArray(parsed)) {
          return parsed.map((t) => String(t)).filter(Boolean);
        }
      } catch {
        /* fall through */
      }
    }
    return s.split(/[\s,]+/).map((x) => x.replace(/^#/, '').trim()).filter(Boolean);
  }
  return [];
}
